import { ContactInfo } from '../api/cart/interfaces'
import UserDataServiceProvider from '../services/UserDataServiceProvider'

/**
 * Helper to cache the storeinfo.
 */
class StoreInfo {
  private storeInfoCache: ContactInfo | null = null

  fetchContactAdressInfo = async (orgId: string): Promise<ContactInfo> => {
    if (this.storeInfoCache) {
      return this.storeInfoCache
    }
    try {
      const data = await UserDataServiceProvider.contactAdressInfo(orgId)
      this.storeInfoCache = data
      return data
    } catch (error) {
      throw new Error(error.toString())
    }
  }

  getContactAdressInfo(): ContactInfo | undefined {
    return this.storeInfoCache
  }
}

export const storeInfo = new StoreInfo()
